import React, { Component } from "react";
import MarkdownPreviewer from "./containers/MarkdownPreviewer";

class App extends Component {
    render() {
        return <MarkdownPreviewer />;
    }
}

export default App;
